import type { MemoizedSelector, Store } from '@ngrx/store';
import type { Observable } from 'rxjs';
import { take } from 'rxjs';
import { map } from 'rxjs/operators';

import type { FullCandidate } from '@core/candidate-types';
import { filterBoolean } from '@core/common-legacy';
import type { CandidateVisitedSnapshot } from '@core/dashboard-types';
import { ResourceKind } from '@core/dashboard-types';

const mapToRecentNavigationSnapshot = (candidate: FullCandidate): CandidateVisitedSnapshot => {
  const { id, name, hasAvatar, initials, photoThumbUrl, isAnonymous } = candidate;
  return {
    id,
    name,
    hasAvatar,
    initials,
    photoThumbUrl,
    kind: ResourceKind.Candidate,
    isAnonymous,
  };
};

export const candidateResolver = (
  store: Store,
  selector: MemoizedSelector<object, FullCandidate | null>,
): Observable<CandidateVisitedSnapshot> =>
  store.select(selector).pipe(filterBoolean, take(1), map(mapToRecentNavigationSnapshot));
